import { render, staticRenderFns } from "./granary.vue?vue&type=template&id=5d073b5e&scoped=true"
import script from "./granary.vue?vue&type=script&lang=js"
export * from "./granary.vue?vue&type=script&lang=js"
import style0 from "./granary.vue?vue&type=style&index=0&id=5d073b5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d073b5e",
  null
  
)

export default component.exports